// extracted by mini-css-extract-plugin
export default {"banner":"LoginPromptBanner_banner__7Bp3O","linkButton":"LoginPromptBanner_linkButton__xOC4t"};